/**
 * AI agent settings API client (BFF: `/api/v1/store/settings/ai-agents`).
 *
 * The tenant's AI configuration — the hub's `agent_settings` row 1:1 (BFF adr-merchant-portal-022
 * D5). The provider credential is write-only on update; the provider check accepts an optional
 * candidate `{provider, model}` and is always `200` for a completed check.
 */
import { apiClient } from '@/shared/api';
import type {
  AiAgentSettings,
  AiProviderCheckRequest,
  AiProviderCheckResult,
  UpdateAiAgentSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/ai-agents';

export const getAiAgentSettings = async (): Promise<AiAgentSettings> =>
  (await apiClient.get<AiAgentSettings>(BASE)).data;

export const updateAiAgentSettings = async (
  body: UpdateAiAgentSettingsRequest,
): Promise<AiAgentSettings> => (await apiClient.put<AiAgentSettings>(BASE, body)).data;

/**
 * No body checks the saved configuration; `{provider, model}` checks a candidate against the
 * STORED credential (never a draft one — AI card doc §7.6).
 */
export const testAiAgentProviderConnection = async (
  body?: AiProviderCheckRequest,
): Promise<AiProviderCheckResult> =>
  (await apiClient.post<AiProviderCheckResult>(`${BASE}/provider/test-connection`, body)).data;
